<ng-container *ngIf="loggedId" [ngTemplateOutlet]="auth"></ng-container>
<ng-container *ngIf="!loggedId" [ngTemplateOutlet]="nonAuth"></ng-container>

<ng-template #auth>
  <router-outlet></router-outlet>
</ng-template>

<ng-template #nonAuth>
  <router-outlet></router-outlet>
<!--  <div *ngIf="registerPath === true">-->
<!--    <app-register></app-register>-->
<!--  </div>-->
<!--  <div *ngIf="registerPath === false">-->
<!--    <app-public-content-layout></app-public-content-layout>-->
<!--  </div>-->
</ng-template>
<ng-container *ngIf="showBot">
  <audio autoplay style="display: none">
    <source src="./assets/sounds/toast_sound.mp3" type="audio/mpeg">
    Your browser does not support the audio element.
  </audio>
  <chat-widget
    botName="Eva"
    [url]="chatUrl"
    [opened]="false"
  ></chat-widget>
</ng-container>
